import axios from "axios";

export default {
  get(context, id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/library/book/${id}`)
        .then((response) => {
          context.commit("setBook", response.data);
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  search(context, params) {
    // const queryString = new URLSearchParams(params).toString();
    return new Promise((resolve, reject) => {
      let path = params.title
        ? `/library/?title__contains=${params.title}&`
        : "/library/?";
      axios
        .get(`${path}limit=100`)
        .then((response) => {
          let books = [];

          if (params.category_id) {
            response.data.results.map((book) => {
              if (
                book.categories.filter(
                  (category) => category.id == params.category_id
                ).length > 0
              ) {
                books.push(book);
              }
            });
          } else if (params.categories) {
            params.categories.map((cat) => {
              response.data.results.map((book) => {
                if (
                  book.categories.filter((category) => category.id == cat.id)
                    .length > 0
                ) {
                  books.push(book);
                }
              });
            });
          } else {
            books = response.data.results;
          }
          // let filteredByCategoryId = response.data.results.filter(book => book.category.id === params.category_id);
          context.commit("setSearchResults", books);
          resolve(books);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getCategories(context) {
    return new Promise((resolve, reject) => {
      axios
        .get("/library/categories")
        .then((response) => {
          context.commit("setCategories", response.data.results);
          resolve(response.data.results);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  getCollections(context) {
    return new Promise((resolve, reject) => {
      axios
        .get("/library/collections")
        .then((response) => {
          context.commit("setCollections", response.data.results);
          resolve(response.data.results);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  getCollectionBooks(context, id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/library/?colletion=${id}&limit=${30}`)
        .then((response) => {
          let filteredBooks = response.data.results.filter((book) => {
            return book.colletion.id === id;
          });
          context.commit("setCollectionBooks", filteredBooks);
          resolve(response.data.results);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  getMasterBooks(context, id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/library/?authors=${id}`)
        .then((response) => {
          // let filteredBooks = [];
          // response.data.results.map((book) => {
          //   if (
          //     book.authors.filter((author) => author.slug == slug).length > 0
          //   ) {
          //     filteredBooks.push(book);
          //   }
          // });
          context.commit("setMasterBooks", response.data.results);

          resolve(response.data.results);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getReadingLibrary(context, user_id) {
    return new Promise((resolve, reject) => {
      window.axios
        .get(
          `/library/books-reading?user_id=${user_id}&end_reading=false&limit=100`
        )
        .then((response) => {
          resolve(response.data.results);
        })
        .catch(reject);
    });
  },
  getFinishedLibrary(context, user_id) {
    return new Promise((resolve, reject) => {
      window.axios
        .get(`/library/books-reading?user_id=${user_id}&end_reading=true`)
        .then((response) => {
          resolve(response.data.results);
        })
        .catch(reject);
    });
  },
  getLibraryCategories(context) {
    return new Promise((resolve, reject) => {
      window.axios
        .get("/library/categories")
        .then((response) => {
          context.commit("setLibraryCategories", response.data.results);
          resolve();
        })
        .catch(reject);
    });
  },
  getLibrary(context) {
    return new Promise((resolve, reject) => {
      window.axios
        .get("/library/")
        .then((response) => {
          context.commit("setLibrary", response.data.results);
          resolve();
        })
        .catch(reject);
    });
  },
  getHighlightedCategoriesLibrary(context, ids) {
    return Promise.all(
      ids.map((id) => {
        if (
          context.state.highlighted_categories_library?.find(
            (category) => category.id == id
          )
        ) {
          return;
        }

        new Promise((resolve, reject) => {
          window.axios
            .get(`/library/`)
            .then((response) => {
              context.commit("pushHighlightedCategoriesLibrary", {
                ...response.data.results,
                id,
              });
              resolve(response.data);
            })
            .catch(reject);
        });
      })
    );
  },
  saveProgress(context, data) {
    return new Promise((resolve, reject) => {
      axios
        .post("/library/progress", data)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  royaltyCreate(context, data) {
    return new Promise((resolve, reject) => {
      axios
        .post("/royalties/royalty-create", data)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  addToMyList(context, book_id) {
    return new Promise((resolve, reject) => {
      window.axios
        .post("/library/mylist/create", {
          book_id,
        })
        .then(function (response) {
          resolve(response.data);
        })
        .catch(reject);
    });
  },
  removeToMyList(context, { user_id, id }) {
    return new Promise((resolve, reject) => {
      window.axios
        .delete(`/library/${user_id}/mylist/${id}`)
        .then((response) => {
          resolve(response.data);
        })
        .catch(reject);
    });
  },
  getMyList(context) {
    return new Promise((resolve, reject) => {
      window.axios
        .get("/library/mylist")
        .then(function (response) {
          context.commit("setMyList", response.data.results);
          resolve();
        })
        .catch(reject);
    });
  },
};
